import * as React from 'react';

var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgComfort = function SvgComfort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    d: "M14.738 7.508a.75.75 0 0 1 .75.75v2.219h2.215a.75.75 0 1 1 0 1.5h-2.215v2.212a.75.75 0 1 1-1.5 0v-2.212h-2.216a.75.75 0 0 1 0-1.5h2.216v-2.22a.75.75 0 0 1 .75-.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M15.664 30.002c-.21-.1-.411-.206-.603-.32a.935.935 0 0 1-.015.019l-2.478 3.112a.75.75 0 0 1-1.174-.935l2.478-3.11a5.841 5.841 0 0 1-1.596-2.833c-.405-1.692-.09-3.553.841-5.205 1.29-2.289 4.13-4.345 7.703-5.432 3.6-1.096 8.026-1.24 12.58.39a.75.75 0 0 1 .18.093c.344.243.518.64.5 1.036a1.21 1.21 0 0 1-.601 1.008.754.754 0 0 1-.198.08c-1.97.482-3.455 1.646-4.722 3.132-1.006 1.181-1.84 2.518-2.672 3.853-.23.37-.461.74-.695 1.106-1.044 1.633-2.18 3.232-3.69 4.114-1.594.93-3.48 1.003-5.838-.108Zm16.218-13.233c-3.87-1.155-7.58-.963-10.625-.036-3.334 1.015-5.79 2.883-6.833 4.733-.77 1.366-.995 2.842-.69 4.12.302 1.264 1.13 2.38 2.57 3.06 2.013.948 3.364.798 4.441.169.714-.417 1.354-1.068 1.988-1.893a9.033 9.033 0 0 0-3.318-.1.75.75 0 0 1-.24-1.48 10.572 10.572 0 0 1 4.482.265 95.369 95.369 0 0 0 .845-1.332 9.053 9.053 0 0 0-3.462-.35.75.75 0 1 1-.148-1.493 10.57 10.57 0 0 1 4.433.533c.634-.989 1.319-1.992 2.093-2.9 1.18-1.386 2.608-2.604 4.464-3.297Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Zm18.5-20c0 10.217-8.283 18.5-18.5 18.5S1.5 30.217 1.5 20 9.783 1.5 20 1.5 38.5 9.783 38.5 20Z",
    clipRule: "evenodd"
  })));
};

export { SvgComfort as default };
//# sourceMappingURL=comfort.svg.js.map
